import * as React from "react";
import PageBreaker from "./PageBreaker";
import PageFooter from "./PageFooter";
import PageHeader from "./PageHeader";

const Page = ({ portfolio, children, className = "" }) => {
  return (
    <div className={`page ${className}`}>
      <PageHeader portfolio={portfolio} />
      {children}
      <PageFooter portfolio={portfolio} pageIndex={0} totalPages={0} />
      <PageBreaker />
    </div>
  );
};

export default Page;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/Page.jsx